import React from 'react'
import Widget from '../../../dpe-usco/components/Widget/Widget'
import { Table } from '../../../dpe-usco'
import TableStatus from '../../../components/subComponents/TableStatus/TableStatus'
import CleanoutSummary from './CleanoutSummary'
import FormatCircles from '../../../components/subComponents/FormatCircles'

const summaryStructure = {
  headers: [
    'Field', 'Planting', 'Harvest'
  ],
  dataKeys: [
    'name',
    'planting',
    'harvest'
  ],
  rowFormat: {
    planting: {
      overwriteStyles: true,
      customStyle: 'df flx1 jcc mr1%',
      format: val => {
        return FormatCircles(val)
      }
    },
    harvest: {
      overwriteStyles: true,
      customStyle: 'df flx1 jcc mr1%',
      format: val => {
        return FormatCircles(val)
      }
    }
  }
}

const StewardshipSummary = ({ status, data, completeStatus, completeData, replantOrLost }) => {

  return (
    <Widget title='Stewardship summary'>
      <Table dataTestId='stewardshipSummary' data={data} structure={summaryStructure} replantOrLost={replantOrLost} statusComponent={status ? <TableStatus status={status} /> : null} />
      <div className='h20' />
      <CleanoutSummary status={completeStatus} data={completeData} />
    </Widget>
  )
}

export default StewardshipSummary